module.exports = __webpack_public_path__ + "img/Download.d56d99d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/Download.png
// module id = 8jTf
// module chunks = 1